import { Component, Fragment } from 'react';
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	Link,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AuthApis from '../../hepler/authApis.service';
import { toast } from 'react-toastify';
import { postMessage } from '../../utils/common.utils';
import { redirectAccountRestrictionsValidator } from '../../utils/targetedAccounts.utils';
import {
	processCompleteEntityConfig,
	is2FAEnabled,
} from '../../utils/entityConfig.utils';
import { withTranslation } from '../../hoc/withTranslation';
import PreLoginCheckSvg from '../../assets/PreLoginCheckSvg.jsx';
// import MobileSim from '../../assets/MobileSim.svg';
import MobileSimSvg from '../../assets/MobileSimSvg.jsx';
import TrustMarker from '../common/TrustMarker';
import JourneySteps from './JourneySteps';
import loginLeftStyles from '../Login/LoginLeft.styles';
import loginStyles from '../Login/Login.styles';
import LoginFooter from '../Sections/LoginFooter';
import Footer from '../Sections/Footer';
import Drawer from '../Drawer/Drawer';
import DialogBox from '../Dialog Box/Dialog Box';
import CancelConsent from '../Accounts/CancelConsent';
import SetTheme from '../common/SetTheme';
import Expired from '../Expired';
import {
	PAGE_HEADING_ID,
	PRE_LOGIN_CANCEL_DRAWER_SUBTITLE_ID,
	PRE_LOGIN_CANCEL_DRAWER_TITLE_ID,
	PRE_LOGIN_PRIVACY_DIALOG_TITLE_ID,
	PRE_LOGIN_SNA_DRAWER_TITLE_ID,
	PRE_LOGIN_SNA_DIALOG_TITLE_ID,
	PRE_LOGIN_TERMS_DIALOG_TITLE_ID,
} from '../../utils/pageHeading.utils';
import {
	keyboardFocusVisibleSx,
	visuallyHiddenSx,
} from '../../utils/a11y.utils';
import {
	getEntityThemedCtaButtonSx,
	getOpaqueDialogSurface,
} from '../../utils/ctaContrast.utils';
import sizeFontCustom from '../Discovery/fontSize.styles';

class PreLogin extends Component {
	constructor(props) {
		super(props);
		const queryParams = new URLSearchParams(window.location.search);
		this.ecreq = queryParams.get('ecreq');
		this.reqdate = queryParams.get('reqdate');
		this.fi = queryParams.get('fi')
			? queryParams.get('fi').split(' ').join('+')
			: null;
		this.requestorType = queryParams.get('requestorType') ?? null;
		this.fips = queryParams.get('fip')
			? window.atob(queryParams.get('fip'))
			: null;
		this.profile = queryParams.get('profile') ?? null;
		this.encryptedConsentId = queryParams.get('consentId') ?? null;
		this.encryptedDisplayName = queryParams.get('displayName') ?? null;

		this.state = {
			theme: undefined,
			isExpired: false,
			showSNADrawer: false,
			showSNADialog: false,
			showTermsModal: false,
			showPrivacyModal: false,
			showCancelDialog: false,
			showCancelDrawer: false,
			headerHeight: 70,
		};
		this.authApis = new AuthApis();
		this.calculateHeaderHeight = () => {
			const appBar = document.querySelector('header.MuiAppBar-root');
			if (!appBar) return;
			const height = Math.ceil(appBar.getBoundingClientRect().height);
			if (height !== this.state.headerHeight) {
				this.setState({ headerHeight: height });
			}

			appBar.querySelectorAll('img').forEach((img) => {
				if (!img.complete) {
					img.addEventListener('load', this.calculateHeaderHeight, {
						once: true,
					});
				}
			});
		};
	}

	componentDidMount() {
		this.calculateHeaderHeight();
		window.addEventListener('resize', this.calculateHeaderHeight);
		window.addEventListener('load', this.calculateHeaderHeight);
		window.addEventListener('finvu:openExitConfirm', this.openExitConfirm);
		requestAnimationFrame(() => this.calculateHeaderHeight());

		const appBar = document.querySelector('header.MuiAppBar-root');
		if (appBar) {
			this.headerObserver = new MutationObserver(this.calculateHeaderHeight);
			this.headerObserver.observe(appBar, {
				childList: true,
				subtree: true,
				attributes: true,
			});
		}

		if (
			this.props.sdkReady &&
			!this.props?.location?.state?.fromTerm &&
			!this.props.redirectToVersion
		) {
			this.getFiuInfo();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.calculateHeaderHeight);
		window.removeEventListener('load', this.calculateHeaderHeight);
		window.removeEventListener('finvu:openExitConfirm', this.openExitConfirm);
		this.headerObserver?.disconnect();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.sdkReady && this.props.sdkReady) {
			this.calculateHeaderHeight();
			requestAnimationFrame(() => this.calculateHeaderHeight);
			if (
				!this.props?.location?.state?.fromTerm &&
				!this.props.redirectToVersion
			) {
				this.getFiuInfo();
			}
		}
	}

	getFiuInfo = () => {
		this.props.updateInitialLoader(true);
		const options = {};
		if (global.renewConsentId) {
			options.encryptedConsentId = global.renewConsentId;
		}
		if (this.encryptedConsentId) {
			options.encryptedConsentId = this.encryptedConsentId;
		}
		if (this.encryptedDisplayName) {
			options.encryptedDisplayName = this.encryptedDisplayName;
		}

		this.authApis
			.getFiuInfo(
				this.ecreq,
				this.reqdate,
				this.fi,
				this.requestorType,
				options,
			)
			.then((res) => {
				if (res?.payload?.status === 'SUCCESS') {
					this.props.toggleTimer();
					const entityId = res.payload?.entityInfo?.entityId;
					global.institutionType = res.payload?.institutionType;
					global.redirectUrl = res.payload?.redirectUrl;
					global.encryptedres = res.payload?.encryptedres;
					global.resDate = res.payload?.resDate;
					global.encryptedFiId = res.payload?.encryptedFiId;
					global.redirectAccountRestrictions =
						redirectAccountRestrictionsValidator(res.payload?.accounts);
					if (global.redirectAccountRestrictions) {
						global.isTargetedDiscoveryMode = true;
					}
					this.fips = res.payload.fips ? res.payload.fips : this.fips;
					global.entityName = res.payload?.entityInfo?.entityName;
					global.mobileNumber = res.payload?.mobileNumber;

					if (entityId) {
						global.entityId = entityId;
						this.getConfigInfo(entityId);
					} else {
						this.props.updateInitialLoader(false);
						if (
							res?.code === undefined ||
							res?.code === null ||
							res?.code === ''
						) {
							toast.error(res?.message);
						} else {
							toast.error(this.props.t(`errors.code.${res.code}`));
						}
					}
				} else {
					global.redirectUrl = res?.message?.redirectUrl;
					global.encryptedres = res?.message?.encryptedres;
					global.resDate = res?.message?.resDate;
					global.encryptedFiId = res?.message?.encryptedFiId;
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res.message);
					} else {
						toast.error(this.props.t(`errors.code.${res.code}`));
					}
					this.setState({ isExpired: true });
					this.props.updateInitialLoader(false);
				}
			});
	};

	getConfigInfo = (entityId) => {
		this.authApis.fiuSdkConfig(entityId).then((res) => {
			if (res?.status === 'SUCCESS') {
				const { themeConfig, updatedFips } = processCompleteEntityConfig(
					res,
					this.profile,
					this.fips,
				);
				if (themeConfig) {
					this.props.updateEntityID(themeConfig);
				}
				this.fips = updatedFips;
				if (global.alternativeText && this.props.changeLanguage) {
					this.props.changeLanguage(this.props.currentLanguage);
				}
				if (!is2FAEnabled(res?.entityConfig?.sdkOptions)) {
					console.log(
						'[PreLogin] enable2FA is not enabled. Redirecting directly to /login',
					);
					this.props.updateInitialLoader(false);
					this.props.history.replace({
						pathname: '/login',
						search: window.location.search,
						state: { fromPreLogin: true },
					});
					return;
				}
			}
			this.props.updateInitialLoader(false);
		});
	};

	openExitConfirm = () => {
		const isMobile = window.innerWidth < 900;
		this.setState(
			isMobile ? { showCancelDrawer: true } : { showCancelDialog: true },
		);
	};

	handleBack = () => {
		postMessage('exit', 'BACK');
		if (global.isRedirect && global.redirectUrl?.includes('?')) {
			window.location.replace(
				`${global.redirectUrl}&ecres=${global.encryptedres}&resdate=${global.resDate}&fi=${global.encryptedFiId}`,
			);
		} else if (global.isRedirect) {
			window.location.replace(
				`${global.redirectUrl}?ecres=${global.encryptedres}&resdate=${global.resDate}&fi=${global.encryptedFiId}`,
			);
		}
	};

	handleContinue = () => {
		this.props.history.push({
			pathname: '/login',
			search: window.location.search,
			state: { fromPreLogin: true },
		});
	};

	handleSnaClose = () => {
		this.setState({ showSNADrawer: false, showSNADialog: false });
	};

	handleSnaUnderstood = () => {
		this.handleSnaClose();
	};

	toggleTermsModal = () => {
		this.setState((prev) => ({ showTermsModal: !prev.showTermsModal }));
	};

	togglePrivacyModal = () => {
		this.setState((prev) => ({ showPrivacyModal: !prev.showPrivacyModal }));
	};

	setTheme = (theme) => {
		this.setState({ theme });
	};

	renderSnaHero = (variant) => {
		const { t } = this.props;

		return (
			<Box sx={{ position: 'relative', lineHeight: 0, flexShrink: 0 }}>
				<MobileSimSvg
					primaryColor={this.props.customDetails?.primaryColor || '#3053D3'}
				/>
				{variant === 'dialog' && (
					<IconButton
						aria-label={t('common.buttons.close')}
						onClick={this.handleSnaClose}
						sx={{
							position: 'absolute',
							top: '0.75rem',
							right: '0.75rem',
							width: '2rem',
							height: '2rem',
							color: '#444444',
							backgroundColor: '#FFFFFF',
							p: '0.25rem',
							boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12)',
							...keyboardFocusVisibleSx,
							'&:hover': {
								backgroundColor: '#FFFFFF',
								opacity: 0.92,
							},
						}}
					>
						<CloseIcon sx={{ fontSize: '1.125rem' }} />
					</IconButton>
				)}
			</Box>
		);
	};

	renderSnaBody = (isDark, titleId) => {
		const { t } = this.props;
		const fontFamily = this.props.customDetails?.fontFamily;
		const headingColor = isDark ? '#FFFFFF' : '#000000';
		const bodyColor = isDark ? '#B0B0B0' : '#666666';

		return (
			<>
				<Typography
					id={titleId}
					component="h2"
					sx={{
						fontFamily,
						color: headingColor,
						fontWeight: 700,
						fontSize: '1rem',
						lineHeight: 1.4,
						mb: '1.25rem',
					}}
				>
					{t('preLogin.sna.title')}
				</Typography>
				<Typography
					component="p"
					sx={{
						fontFamily,
						color: bodyColor,
						fontSize: '0.875rem',
						lineHeight: 1.5,
						mb: '1.25rem',
					}}
				>
					{t('preLogin.sna.description')}
				</Typography>
				<Typography
					component="p"
					sx={{
						fontFamily,
						color: bodyColor,
						fontSize: '0.875rem',
						lineHeight: 1.5,
						mb: '0.75rem',
					}}
				>
					{t('preLogin.sna.supportedLabel')}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						gap: 1.25,
						mb: '1.25rem',
					}}
				>
					<img
						src="https://cdn.finvu.in/finvulogos/jio.svg"
						alt="Jio"
						style={{ width: '20px', height: '20px' }}
					/>
					<img
						src="https://cdn.finvu.in/finvulogos/airtel-logo-icon.svg"
						alt="Airtel"
						style={{ width: '20px', height: '20px' }}
					/>
					<img
						src="https://cdn.finvu.in/finvulogos/VI.svg"
						alt="VI"
						style={{ width: '20px', height: '20px' }}
					/>
				</Box>
				<Typography
					component="p"
					sx={{
						fontFamily,
						color: bodyColor,
						...sizeFontCustom.subHeading,
						lineHeight: 1.6,
					}}
				>
					{t('preLogin.sna.note')}
				</Typography>
			</>
		);
	};

	renderSnaActions = (isDark, dividerMt = '2.5rem') => {
		const { t } = this.props;
		const primaryColor = this.props.customDetails?.primaryColor || '#3053D3';

		return (
			<Box>
				<Divider
					sx={{
						mt: dividerMt,
						mb: '1.5rem',
						marginLeft: '-1.5rem',
						marginRight: '-1.5rem',
						width: 'calc(100% + 3rem)',
					}}
				/>
				<Button
					variant="contained"
					size="large"
					fullWidth
					onClick={this.handleSnaUnderstood}
					sx={getEntityThemedCtaButtonSx(this.props.customDetails, isDark, {
						textTransform: 'capitalize',
						fontSize: '0.875rem',
						border: `1px solid ${
							this.props.customDetails?.ctaBorderColor ?? primaryColor
						}`,
						borderRadius: this.props.customDetails?.borderRadius ?? '6px',
						fontFamily: this.props.customDetails?.fontFamily,
						boxShadow: 'none',
						...keyboardFocusVisibleSx,
						'&:hover': { boxShadow: 'none' },
					})}
				>
					{t('common.buttons.understood') || 'Understood'}
				</Button>
			</Box>
		);
	};

	renderSnaDrawer = (isDark) => {
		const contentBackground = isDark
			? '#161616'
			: this.props.customDetails?.secondaryColor || '#fff';

		return (
			<Drawer
				open={this.state.showSNADrawer}
				setOpen={(open) => this.setState({ showSNADrawer: open })}
				anchor="bottom"
				height="auto"
				customDetails={this.props.customDetails}
				showCloseBtn={false}
				flushBottom
				ariaLabelledBy={PRE_LOGIN_SNA_DRAWER_TITLE_ID}
			>
				<Box
					sx={{
						backgroundColor: contentBackground,
						fontFamily: this.props.customDetails?.fontFamily,
						overflow: 'hidden',
					}}
				>
					{this.renderSnaHero('drawer')}
					<Box
						sx={{
							px: '1.5rem',
							pt: '1.5rem',
							pb: '1.5rem',
							textAlign: 'start',
						}}
					>
						{this.renderSnaBody(isDark, PRE_LOGIN_SNA_DRAWER_TITLE_ID)}
						{this.renderSnaActions(isDark)}
					</Box>
				</Box>
				<Footer customDetails={this.props.customDetails} />
			</Drawer>
		);
	};

	renderSnaDialog = (isDark) => {
		const contentBackground = getOpaqueDialogSurface(isDark);

		return (
			<Dialog
				open={this.state.showSNADialog}
				onClose={this.handleSnaClose}
				aria-labelledby={PRE_LOGIN_SNA_DIALOG_TITLE_ID}
				maxWidth={false}
				sx={{
					'& .MuiDialog-paper': {
						width: '100%',
						maxWidth: '28rem',
						borderRadius: '16px',
						overflow: 'hidden',
						margin: '1rem',
						backgroundColor: contentBackground,
					},
				}}
			>
				{this.renderSnaHero('dialog')}
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						minHeight: '17.5rem',
						px: '1.5rem',
						pt: '1.5rem',
						pb: '1.5rem',
						textAlign: 'start',
						backgroundColor: contentBackground,
						fontFamily: this.props.customDetails?.fontFamily,
					}}
				>
					<Box sx={{ flex: 1 }}>
						{this.renderSnaBody(isDark, PRE_LOGIN_SNA_DIALOG_TITLE_ID)}
					</Box>
					{this.renderSnaActions(isDark, '1.5rem')}
				</Box>
			</Dialog>
		);
	};

	render() {
		if (!this.props.sdkReady) {
			return (
				<Box sx={{ display: 'flex', p: 2 }}>
					<CircularProgress />
				</Box>
			);
		}

		const { t } = this.props;
		const isDark =
			this.props.customDetails?.darkTheme === true ||
			this.state.theme?.palette?.mode === 'dark';
		const isMobile = window.innerWidth < 1200;
		const primaryColor = this.props.customDetails?.primaryColor || '#3053D3';
		const showTrustMarker =
			this.props.customDetails?.disableTrustMarkers !== 'true';
		const entityName = global.entityName || 'your institution';

		if (this.state.isExpired) {
			return <Expired />;
		}

		const journeySteps = [
			{
				imgName: 'Register',
				title: t('preLogin.steps.register.title'),
				description: t('preLogin.steps.register.description'),
				onLearnMore: () =>
					this.setState(
						isMobile ? { showSNADrawer: true } : { showSNADialog: true },
					),
				learnMoreLabel: t('preLogin.steps.register.learnMore'),
				learnMoreAriaLabel: t('preLogin.steps.register.learnMoreAria'),
			},
			{
				imgName: 'Select_Accounts',
				title: t('preLogin.steps.selectAccounts.title'),
				description: t('preLogin.steps.selectAccounts.description'),
			},
			{
				imgName: 'Approve_Consent',
				title: t('preLogin.steps.approveConsents.title'),
				description: t('preLogin.steps.approveConsents.description'),
			},
		];

		return (
			<Box
				sx={{
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
					backgroundColor: isDark ? '#161616' : '#fff',
					boxSizing: 'border-box',
					pt: { xs: 0, lg: `${this.state.headerHeight}px` },
				}}
			>
				{/* Mobile / Tablet hero */}
				<Box
					sx={{
						display: { xs: 'block', lg: 'none' },
						flexShrink: 0,
						backgroundColor: primaryColor,
						pt: `${this.state.headerHeight}px`,
					}}
				>
					<Box
						sx={{
							px: 0,
							pb: 0,
							maxWidth: { xs: '100%', sm: '480px', md: '560px' },
							mx: 'auto',
						}}
					>
						<PreLoginCheckSvg primaryColor={primaryColor} />
					</Box>
				</Box>

				{showTrustMarker && (
					<Box
						sx={{
							width: '100%',
							flexShrink: 0,
							display: { xs: 'none', lg: 'block' },
							'& > div': {
								padding: '12px 20px !important',
							},
						}}
					>
						<TrustMarker
							customDetails={this.props.customDetails}
							noBorderRadius
						/>
					</Box>
				)}

				<Box
					sx={{
						...loginLeftStyles.container,
						flex: 1,
						minHeight: 0,
						overflow: 'hidden',
						paddingTop: {
							xs: 0,
							md: 0,
						},
					}}
				>
					<SetTheme
						customDetails={this.props.customDetails}
						setTheme={this.setTheme}
					/>

					{/* Left / main content */}
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							flex: { xs: 1, lg: 1 },
							minWidth: 0,
							backgroundColor: isDark ? '#161616' : '#fff',
							overflow: 'hidden',
						}}
					>
						<Box
							sx={{
								flex: 1,
								minHeight: 0,
								overflowY: 'auto',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							{showTrustMarker && (
								<Box
									sx={{
										flexShrink: 0,
										display: { xs: 'block', lg: 'none' },
									}}
								>
									<TrustMarker
										customDetails={this.props.customDetails}
										noBorderRadius
									/>
								</Box>
							)}

							<Box
								sx={{
									width: '100%',
									maxWidth: {
										xs: '100%',
										sm: '480px',
										md: '560px',
										lg: '100%',
									},
									mx: 'auto',
									px: { xs: '1.5rem', lg: '4rem', xl: '5.5rem' },
									pt: { xs: '1.25rem', lg: '2rem' },
									pb: { xs: '1rem', lg: '1.5rem' },
								}}
							>
								<Typography
									id={PAGE_HEADING_ID}
									component="h1"
									sx={{
										...loginStyles.headingText,
										textAlign: 'center',
										lineHeight: 1.45,
										mb: { xs: '1.25rem', lg: '1.75rem' },
										fontFamily: this.props.customDetails?.fontFamily,
										color:
											this.props.customDetails?.primaryTextColor ??
											(isDark ? '#fff' : '#111'),
									}}
								>
									{t('preLogin.title')
										.split('{entityName}')
										.map((part, index, parts) =>
											index < parts.length - 1 ? (
												<Fragment key={index}>
													{part}
													<Box component="span" sx={{ fontWeight: 600 }}>
														{entityName}
													</Box>
												</Fragment>
											) : (
												part
											),
										)}
								</Typography>

								<Box
									component="section"
									aria-labelledby={PAGE_HEADING_ID}
									sx={{
										border: `1px solid ${isDark ? '#3D3D3D' : '#E0E0E0'}`,
										borderRadius: '8px',
										overflow: 'hidden',
										backgroundColor: isDark ? '#1E1E1E' : '#fff',
									}}
								>
									<Box
										component="ol"
										sx={{
											listStyle: 'none',
											m: 0,
											p: 0,
										}}
									>
										{journeySteps.map((step, index) => (
											<JourneySteps
												key={step.imgName}
												{...step}
												isLast={index === journeySteps.length - 1}
												customDetails={this.props.customDetails}
												isDark={isDark}
											/>
										))}
									</Box>
								</Box>
							</Box>
						</Box>

						<Box
							sx={{
								flexShrink: 0,
								width: '100%',
								maxWidth: { xs: '100%', sm: '480px', md: '560px', lg: '100%' },
								mx: 'auto',
								px: { xs: '1.5rem', lg: '4rem', xl: '5.5rem' },
								pb: { xs: '0.5rem', lg: '1.5rem' },
								backgroundColor: isDark ? '#161616' : '#fff',
							}}
						>
							{showTrustMarker && !isMobile && (
								<Box sx={{ mb: '0.75rem' }}>
									<LoginFooter mode="secure" />
								</Box>
							)}
							<Divider
								sx={{
									mx: { xs: '-1.5rem', lg: '-4rem', xl: '-5.5rem' },
									width: {
										xs: 'calc(100% + 3rem)',
										lg: 'calc(100% + 8rem)',
										xl: 'calc(100% + 11rem)',
									},
									mb: '0.75rem',
								}}
							/>
							<Button
								variant="contained"
								size="large"
								fullWidth
								endIcon={<ArrowForwardIcon aria-hidden="true" />}
								onClick={this.handleContinue}
								sx={getEntityThemedCtaButtonSx(
									this.props.customDetails,
									isDark,
									{
										textTransform: 'capitalize',
										fontSize: '0.875rem',
										border: `1px solid ${
											this.props.customDetails?.ctaBorderColor ?? primaryColor
										}`,
										borderRadius:
											this.props.customDetails?.borderRadius ?? '6px',
										fontFamily: this.props.customDetails?.fontFamily,
										boxShadow: 'none',
										...keyboardFocusVisibleSx,
										'&:hover': { boxShadow: 'none' },
									},
								)}
							>
								{t('common.buttons.continue')}
							</Button>
							<Typography
								component="p"
								sx={{
									...loginStyles.tncLabel,
									textAlign: 'center',
									mt: '0.75rem',
									color:
										this.props.customDetails?.secondaryTextColor ??
										(isDark ? '#7A8185' : '#6C6C6C'),
									fontFamily: this.props.customDetails?.fontFamily,
								}}
							>
								{t('preLogin.agreementPrefix')}&nbsp;
								<Link
									component="button"
									type="button"
									underline="always"
									fontWeight={700}
									onClick={this.toggleTermsModal}
									sx={{
										color:
											this.props.customDetails?.primaryTextColor ??
											(isDark ? '#fff' : primaryColor),
										fontFamily: this.props.customDetails?.fontFamily,
										fontSize: '0.75rem',
										verticalAlign: 'baseline',
										textUnderlineOffset: '2px',
										...keyboardFocusVisibleSx,
									}}
								>
									{t('login.titles.termsAndConditions')}
								</Link>
								&nbsp;&amp;&nbsp;
								<Link
									component="button"
									type="button"
									underline="always"
									fontWeight={700}
									onClick={this.togglePrivacyModal}
									sx={{
										color:
											this.props.customDetails?.primaryTextColor ??
											(isDark ? '#fff' : primaryColor),
										fontFamily: this.props.customDetails?.fontFamily,
										fontSize: '0.75rem',
										verticalAlign: 'baseline',
										textUnderlineOffset: '2px',
										...keyboardFocusVisibleSx,
									}}
								>
									{t('login.titles.privacyPolicy')}
								</Link>
							</Typography>
						</Box>
					</Box>

					{/* Desktop hero panel */}
					<Box
						sx={{
							display: { xs: 'none', lg: 'block' },
							flex: 2,
							minHeight: 0,
							minWidth: 0,
							alignSelf: 'stretch',
							overflow: 'hidden',
							backgroundColor: primaryColor,
							position: 'relative',
						}}
					>
						<PreLoginCheckSvg
							primaryColor={primaryColor}
							preserveAspectRatio="xMidYMid slice"
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
							}}
						/>
					</Box>
				</Box>

				<Footer customDetails={this.props.customDetails} embedded />

				{isMobile ? this.renderSnaDrawer(isDark) : this.renderSnaDialog(isDark)}

				<DialogBox
					open={this.state.showCancelDialog}
					handleClose={() => this.setState({ showCancelDialog: false })}
					customDetails={this.props.customDetails}
				>
					<CancelConsent
						handleCancel={() => this.setState({ showCancelDialog: false })}
						handleDeny={this.handleBack}
						customDetails={this.props.customDetails}
					/>
				</DialogBox>

				<Drawer
					open={this.state.showCancelDrawer}
					setOpen={(open) => this.setState({ showCancelDrawer: open })}
					anchor="bottom"
					height="auto"
					customDetails={this.props.customDetails}
					showCloseBtn={false}
					ariaLabelledBy={PRE_LOGIN_CANCEL_DRAWER_TITLE_ID}
					ariaDescribedBy={PRE_LOGIN_CANCEL_DRAWER_SUBTITLE_ID}
				>
					<Box
						sx={{
							padding: '1.5rem',
							fontFamily: this.props.customDetails?.fontFamily,
							backgroundColor: isDark
								? '#161616'
								: this.props.customDetails?.secondaryColor || '#fff',
						}}
					>
						<Typography
							id={PRE_LOGIN_CANCEL_DRAWER_TITLE_ID}
							component="h2"
							sx={{
								fontSize: '1rem',
								fontWeight: 600,
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#fff' : '#000',
								marginBottom: '0.5rem',
							}}
						>
							{t('header.dialog.cancelConsent.title')}
						</Typography>
						<Typography
							id={PRE_LOGIN_CANCEL_DRAWER_SUBTITLE_ID}
							sx={{
								fontSize: '0.875rem',
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#B0B0B0' : '#666',
								marginBottom: '2rem',
							}}
						>
							{t('header.dialog.cancelConsent.subtitle')}
						</Typography>
						<CancelConsent
							handleCancel={() => this.setState({ showCancelDrawer: false })}
							handleDeny={this.handleBack}
							customDetails={this.props.customDetails}
						/>
					</Box>
					<Box sx={{ marginBottom: '-1rem' }}>
						<Footer {...this.props} />
					</Box>
				</Drawer>

				<Dialog
					open={this.state.showTermsModal}
					onClose={this.toggleTermsModal}
					fullWidth
					maxWidth="md"
					aria-labelledby={PRE_LOGIN_TERMS_DIALOG_TITLE_ID}
					disableEnforceFocus
					sx={{
						'& .MuiDialog-paper': {
							overflow: 'hidden',
							touchAction: 'auto',
							padding: '0px',
							backgroundColor: isDark ? '#161616' : '#fff',
							color: isDark ? '#fff' : '#000',
						},
					}}
				>
					<DialogTitle
						id={PRE_LOGIN_TERMS_DIALOG_TITLE_ID}
						sx={visuallyHiddenSx}
					>
						{t('login.titles.termsAndConditions')}
					</DialogTitle>
					<DialogContent
						sx={{
							height: { xs: '80vh', sm: '500px' },
							padding: '0px',
							position: 'relative',
						}}
					>
						<IconButton
							aria-label={t('common.buttons.close')}
							onClick={this.toggleTermsModal}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								zIndex: 2,
								color: isDark ? '#fff' : '#000',
								...keyboardFocusVisibleSx,
							}}
						>
							<CloseIcon />
						</IconButton>
						<iframe
							src="https://finvu.in/terms"
							title={t('login.titles.termsAndConditions')}
							width="100%"
							height="100%"
							style={{
								border: 'none',
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
							}}
						/>
					</DialogContent>
				</Dialog>

				<Dialog
					open={this.state.showPrivacyModal}
					onClose={this.togglePrivacyModal}
					fullWidth
					maxWidth="md"
					aria-labelledby={PRE_LOGIN_PRIVACY_DIALOG_TITLE_ID}
					disableEnforceFocus
					sx={{
						'& .MuiDialog-paper': {
							overflow: 'hidden',
							touchAction: 'auto',
							padding: '0px',
							backgroundColor: isDark ? '#161616' : '#fff',
							color: isDark ? '#fff' : '#000',
						},
					}}
				>
					<DialogTitle
						id={PRE_LOGIN_PRIVACY_DIALOG_TITLE_ID}
						sx={visuallyHiddenSx}
					>
						{t('login.titles.privacyPolicy')}
					</DialogTitle>
					<DialogContent
						sx={{
							height: { xs: '80vh', sm: '500px' },
							padding: '0px',
							position: 'relative',
						}}
					>
						<IconButton
							aria-label={t('common.buttons.close')}
							onClick={this.togglePrivacyModal}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								zIndex: 2,
								color: isDark ? '#fff' : '#000',
								...keyboardFocusVisibleSx,
							}}
						>
							<CloseIcon />
						</IconButton>
						<iframe
							src="https://finvu.in/privacy"
							title={t('login.titles.privacyPolicy')}
							width="100%"
							height="100%"
							style={{
								border: 'none',
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
							}}
						/>
					</DialogContent>
				</Dialog>
			</Box>
		);
	}
}

export default withTranslation(PreLogin);
